import {
  CONCEPTS_WITH_INTEREST,
  REFERENCE_GENERATION_DAYS_LIMIT,
} from '@core/constants';
import { CollectionNoticeModel } from '@core/models';

export function dateDiff(date: string): boolean {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const deadlineAt = new Date(date);
  return (
    (deadlineAt.getTime() - currentDate.getTime()) / (1000 * 3600 * 24) <=
    REFERENCE_GENERATION_DAYS_LIMIT
  );
}

export function isApplicableDate(): boolean {
  const today = new Date();
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const daysRemaining = lastDayOfMonth.getDate() - today.getDate();
  return daysRemaining > REFERENCE_GENERATION_DAYS_LIMIT;
}

export function isConceptWithInterest(
  collectionNotice: CollectionNoticeModel
): boolean {
  return CONCEPTS_WITH_INTEREST.some(
    (ids) => collectionNotice.concept.id === ids
  );
}
